module.exports = __webpack_public_path__ + "img/m.c08253f2.webp";